(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var compact = window.matchMedia('(max-width: 749px)').matches;
  var transitions = [];
  var transitionTicking = false;
  var feedbackTimers = new WeakMap();

  document.documentElement.classList.add('mw-symbol-motion');

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function smoothstep(value) {
    return value * value * (3 - 2 * value);
  }

  function updateTransitions() {
    transitionTicking = false;
    transitions.forEach(function (item) {
      var rect = item.section.getBoundingClientRect();
      var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mw-header-h')) || 97;
      var travel = Math.max(1, item.section.offsetHeight - item.stage.offsetHeight);
      var progress = clamp((header - rect.top) / travel, 0, 1);
      var eased = smoothstep(progress);
      var scale = 1 + eased * 13;
      var veilOpacity = progress < 0.78 ? 1 : 1 - (progress - 0.78) / 0.22;
      var labelOpacity = clamp(0.58 * (1 - progress * 1.7), 0, 0.58);

      item.section.style.setProperty('--mw-symbol-scale', scale.toFixed(4));
      item.section.style.setProperty('--mw-symbol-veil-opacity', clamp(veilOpacity, 0, 1).toFixed(4));
      item.section.style.setProperty('--mw-symbol-label-opacity', labelOpacity.toFixed(4));
    });
  }

  function requestTransitionUpdate() {
    if (transitionTicking || reduced || compact || !transitions.length) return;
    transitionTicking = true;
    window.requestAnimationFrame(updateTransitions);
  }

  function initTransitions(root) {
    (root || document).querySelectorAll('[data-mw-symbol-transition]').forEach(function (section) {
      if (section.dataset.mwSymbolReady) return;
      section.dataset.mwSymbolReady = '1';
      var stage = section.querySelector('.mw-symbol-transition__stage');
      if (!stage) return;
      transitions.push({ section: section, stage: stage });
    });
    requestTransitionUpdate();
  }

  function initImageReveals(root) {
    (root || document).querySelectorAll('[data-mw-symbol-image-reveal]').forEach(function (element) {
      if (element.dataset.mwSymbolReady) return;
      element.dataset.mwSymbolReady = '1';

      if (reduced || !('IntersectionObserver' in window)) {
        element.classList.add('is-symbol-revealed');
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-symbol-revealed');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      observer.observe(element);
    });
  }

  function initSliderSignatures(root) {
    (root || document).querySelectorAll('[data-mw-symbol-slider]').forEach(function (nav) {
      if (nav.dataset.mwSymbolReady) return;
      nav.dataset.mwSymbolReady = '1';

      nav.querySelectorAll('[data-mw-prev], [data-mw-next]').forEach(function (button) {
        button.addEventListener('click', function () {
          var directionClass = button.hasAttribute('data-mw-next') ? 'is-symbol-next' : 'is-symbol-prev';
          nav.classList.remove('is-symbol-next', 'is-symbol-prev');
          window.requestAnimationFrame(function () {
            nav.classList.add(directionClass);
            window.setTimeout(function () {
              nav.classList.remove(directionClass);
            }, 240);
          });
        });
      });
    });
  }

  function playFeedback(target) {
    var surface = target.closest('[data-mw-symbol-feedback]');
    if (!surface) return;
    var existing = feedbackTimers.get(surface);
    if (existing) window.clearTimeout(existing);
    surface.classList.remove('is-symbol-feedback');
    window.requestAnimationFrame(function () {
      surface.classList.add('is-symbol-feedback');
      feedbackTimers.set(surface, window.setTimeout(function () {
        surface.classList.remove('is-symbol-feedback');
        feedbackTimers.delete(surface);
      }, 320));
    });
  }

  function init(root) {
    initTransitions(root);
    initImageReveals(root);
    initSliderSignatures(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.addEventListener('scroll', requestTransitionUpdate, { passive: true });
  window.addEventListener('resize', requestTransitionUpdate);
  document.addEventListener('mw:symbol-feedback', function (event) {
    if (!reduced && event.target instanceof Element) playFeedback(event.target);
  });
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
